
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import Modal from '@/components/Modal.vue';
	import SearchSVG from '@/components/SearchSVG.vue';
	import { Observer } from 'mobx-vue';
	import { Patient } from '@/store/engine/openapi/generated';
	import DualButtonModal from '@/components/modals/DualButtonModal.vue';
	import UtilsStore from '@/store/utilsStore';

	@Observer
	@Component({
		components: { DualButtonModal, Modal, SearchSVG }
	})
	export default class PatientRow extends Vue {
		@Prop({ required: true }) patient: Patient | undefined;
		@Prop({ required: false }) privacy;
		@Prop({ required: true }) tab;

		private menu: boolean = false;
		private modal: boolean = false;
		private cannotDeleteModal: boolean = false;
		private deleted: boolean = false;

		private toPrivateName(name: string) {
			return name[0] + '.';
		}

		private toPrivateId(id: string) {
			if (id.length > 5) {
				const temp = id.substr(id.length - 5);
				return id.substr(0, id.length - 5).replace(/[A-Z 0-9]/gi, '*') + temp;
			} else {
				return id;
			}
		}

		handleFocusOut() {
			this.menu = false;
		}

		private async deleteUser() {
			try {
				const deleted = await this.$state.engine.profile.deleteUser(this.patient?.user?.userID ?? '');
				this.modal = false;
				if (deleted) {
					this.$emit('patientDelete', this.patient);
				} else {
					this.$state.utils.pushMessage('Error while deleting patient!');
				}
			} catch (e) {
				console.error(e);
			}
		}

		private timestampToDate(val) {
			if (+val <= -2209118287000) {
				return '-';
			}
			const date = new Date(+val);
			const year = date.getUTCFullYear();
			const month = date.getUTCMonth();
			const day = date.getUTCDate();
			return month + 1 + '/' + day + '/' + year;
		}

		private toggleMenu() {
			this.menu = !this.menu;
		}

		private toggleModal() {
			if (this.patient && this.patient.sessionsStatuses) {
				this.patient.sessionsStatuses.find(
					(item) =>
						item &&
						(item['status'] === 'SESSION_STATUS_ORDER_CREATED' ||
							item['status'] === 'SESSION_STATUS_ORDER_CANCELLED' ||
							item['status'] === 'SESSION_STATUS_ORDER_DELIVERED')
				)
					? (this.cannotDeleteModal = true)
					: (this.modal = true);
			}
		}

		private lastUpdateParse(val: string) {
			try {
				let date = val.split('T')[0];
				let months = date.split('-')[1];
				let years = date.split('-')[0];
				let day = date.split('-')[2];

				let time = val.split('T')[1];
				time = time.slice(0, -1);

				let toLocalTime = new Date(months + '/' + day + '/' + years + ' ' + time.split('.')[0] + ' UTC');

				// return toLocalTime.getMonth() + 1 + '/' + toLocalTime.getDate() + '/' + toLocalTime.getFullYear() + ' ' + toLocalTime.toLocaleTimeString('en-US');
				return toLocalTime.toLocaleDateString('en-US') + ' ' + toLocalTime.toLocaleTimeString('en-US');
			} catch (e) {
				return 'unknown';
			}
		}

		private onPatientClick() {
			this.$emit('patientClick', this.patient);
		}
	}
